import { useQuery } from '@tanstack/react-query';
import { useGql } from '@ah/design';
import { Header, PillTabs, PullToRefresh, type PillTab } from '@ah/design/mobile';
import { Bookmark } from 'lucide-react';
import { SAVED_VIDEOS_QUERY, type VideoListItem } from '../shared/index.ts';
import { VideoRow, VideoListSkeleton, ErrorRetry } from './_parts.tsx';

const TABS: PillTab[] = [
  { to: '/videos',          label: 'For You', end: true },
  { to: '/videos/latest',   label: 'Latest' },
  { to: '/videos/channels', label: 'Channels' },
  { to: '/videos/seen',     label: 'Watched' },
  { to: '/videos/saved',    label: 'Saved' },
];

export function SavedVideos() {
  const gql = useGql();
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['videos', 'saved'],
    queryFn: async () => {
      const res = await gql.request<{ savedVideos: VideoListItem[] }>(SAVED_VIDEOS_QUERY, { limit: 100 });
      return res.savedVideos;
    },
  });

  return (
    <div className="fixed inset-0 flex flex-col bg-background">
      <Header title="Videos" />
      <PillTabs tabs={TABS} />
      <PullToRefresh className="flex-1 px-3 py-3" onRefresh={() => refetch()}>
        {isLoading ? (
          <VideoListSkeleton />
        ) : error ? (
          <ErrorRetry label="Could not load videos." onRetry={() => refetch()} />
        ) : !data || data.length === 0 ? (
          <div className="text-center py-16 text-muted-foreground">
            <Bookmark size={32} className="mx-auto mb-2 opacity-50" />
            <p className="text-sm">Nothing saved yet. Tap Save on a video to bookmark it for later.</p>
          </div>
        ) : (
          <div className="space-y-4">
            {data.map((v) => <VideoRow key={v.id} v={v} />)}
          </div>
        )}
      </PullToRefresh>
    </div>
  );
}
